import React from 'react';
import { Linkedin, Twitter, Mail, MapPin, Phone } from 'lucide-react';
type Page = 'home' | 'about' | 'services' | 'contact';
interface FooterProps {
  onNavigate: (page: Page) => void;
}
export function Footer({
  onNavigate
}: FooterProps) {
  return <footer className="bg-gray-900 text-white pt-20 pb-10" data-id="element-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-14">
          <div className="col-span-1 md:col-span-2" data-id="element-15">
            <div className="flex items-center mb-6 cursor-pointer gap-0" onClick={() => onNavigate('home')} data-id="element-16">
              <img src="https://cdn.magicpatterns.com/uploads/dnd93BGVureCvbqD8kLcPj/Whiterock_Icon.png" alt="" className="h-7 brightness-0 invert opacity-80 -mr-1" data-id="element-17" />
              <img src="https://cdn.magicpatterns.com/uploads/3dSrKM3ghNM5VaqUnLUSSd/Whiterock_Partners.png" alt="Whiterock Partners" className="h-8 brightness-0 invert opacity-80" data-id="element-18" />
            </div>
            <p className="text-gray-400 max-w-md mb-8 leading-relaxed" data-id="element-19">
              Whiterock Partners is a boutique retained executive search firm
              dedicated to helping high-tech companies build world-class
              leadership teams.
            </p>
            <div className="flex space-x-6" data-id="element-20">
              <a href="https://www.linkedin.com/company/whiterock-partners/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" data-id="element-21">
                <Linkedin size={24} data-id="element-22" />
              </a>
              <a href="tel:+15124761595" className="text-gray-400 hover:text-white transition-colors" data-id="element-23">
                <Phone size={24} data-id="element-24" />
              </a>
              <a href="#" onClick={e => {
              e.preventDefault();
              onNavigate('contact');
            }} className="text-gray-400 hover:text-white transition-colors" data-id="element-25">
                <Mail size={24} data-id="element-26" />
              </a>
            </div>
          </div>

          <div data-id="element-27">
            <h4 className="text-lg font-bold mb-6 uppercase tracking-wider" data-id="element-28">
              Navigation
            </h4>
            <ul className="space-y-4" data-id="element-29">
              <li data-id="element-30">
                <a href="#" onClick={e => {
                e.preventDefault();
                onNavigate('about');
              }} className="text-gray-400 hover:text-white transition-colors cursor-pointer" data-id="element-31">
                  About Us
                </a>
              </li>
              <li data-id="element-32">
                <a href="#" onClick={e => {
                e.preventDefault();
                onNavigate('services');
              }} className="text-gray-400 hover:text-white transition-colors cursor-pointer" data-id="element-33">
                  Our Services
                </a>
              </li>
              <li data-id="element-34">
                <a href="#" onClick={e => {
                e.preventDefault();
                onNavigate('contact');
              }} className="text-gray-400 hover:text-white transition-colors cursor-pointer" data-id="element-35">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-36">
            <h4 className="text-lg font-bold mb-6 uppercase tracking-wider" data-id="element-37">
              Contact
            </h4>
            <ul className="space-y-4 text-gray-400" data-id="element-38">
              <li className="flex items-start" data-id="element-39">
                <MapPin size={20} className="mr-3 mt-1 flex-shrink-0" data-id="element-40" />
                <span data-id="element-41">
                  Austin, Texas
                  <br data-id="element-42" />
                  United States
                </span>
              </li>
              <li className="flex items-center" data-id="element-43">
                <Phone size={20} className="mr-3 flex-shrink-0" data-id="element-44" />
                <span data-id="element-45">(512) 476-1595</span>
              </li>
              <li className="flex items-center" data-id="element-46">
                <Mail size={20} className="mr-3 flex-shrink-0" data-id="element-47" />
                <span data-id="element-48">hello@whiterock.partners</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500" data-id="element-49">
          <p data-id="element-50">
            &copy; {new Date().getFullYear()} Whiterock Partners. All rights
            reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-51">
            <a href="#" className="hover:text-white transition-colors" data-id="element-52">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-53">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}